import { CriterionEditor } from '@/components/admin/criteres/criterion-editor';
import { Link, createFileRoute } from '@tanstack/react-router';

/**
 * Le critère neuf - the empty editor (refonte modulaire §6; maquette
 * `NouveauCritere`).
 *
 * ## It calls NOTHING
 *
 * « Avant ce premier enregistrement il n'existe ni entité ni brouillon
 * serveur : la saisie ne vit que dans la page » (§6). So this route has no
 * query, no autosave and nothing to reload - which is also why it is a route of
 * its own rather than `/admin/criteres/$criterionId` with a sentinel id: an
 * editor that had to answer « is this id real » on every write would carry the
 * branch in nine places instead of in one `detail === null`.
 *
 * The static segment wins over the dynamic one in TanStack Router, so
 * `/admin/criteres/nouveau` can never be read as a criterion called
 * « nouveau ».
 *
 * `onView` and `onCloseView` are no-ops here, and that is honest rather than
 * lazy: there is no history to open a version from, so the gesture cannot be
 * reached - `CriterionHistory` renders its « Aucune version » sentence instead
 * of a single line.
 */

export const Route = createFileRoute('/admin/criteres/nouveau')({
  component: NouveauCriterePage,
});

function NouveauCriterePage() {
  return (
    <div className="space-y-6">
      <p className="text-gray-600 text-sm">
        <Link to="/admin/criteres" className="text-bleu-nuit underline underline-offset-2">
          Critères
        </Link>
        <span className="mx-2">›</span>
        Nouveau critère
      </p>
      <CriterionEditor
        detail={null}
        viewing={null}
        onView={() => undefined}
        onCloseView={() => undefined}
        onReload={() => undefined}
      />
    </div>
  );
}
